export default {
  overlayPlaySvgFill: {
    fill: data => data.color,
  },
  overlayPlaySvgStroke: {
    stroke: data => data.color,
  },
};



// WEBPACK FOOTER //
// ./default-modules/ui/overlay/overlay.theme.ts